import React from 'react';
import { AuthData } from '../../context/auth';
import { ConfigData } from '../../context/config';
import {
	PremiumReportData,
	withPremiumReportContext,
} from '../../context/premiumReport';
import {
	StyledSectionContainer,
	StyledTitle,
	StyledTitleContainer,
} from '../common';
import DocumentsTable from '../DocumentsTable';

interface Props {
	authData: AuthData;
	configData: ConfigData;
	premiumReportData: PremiumReportData;
}

const Documents = (props: Props) => {
	const { premiumReport } = props.premiumReportData;

	const documents = premiumReport.documents;

	return (
		<>
			<StyledTitleContainer>
				<StyledTitle>Documents</StyledTitle>
			</StyledTitleContainer>
			<hr />
			<StyledSectionContainer>
				<DocumentsTable documents={documents} />
			</StyledSectionContainer>
		</>
	);
};

export default withPremiumReportContext<Props>(Documents);
